import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

const opts = {
  theme: {
    iconfont: 'mdi',
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#78B943',
        secondary: '#F9971C',
        accent: '#31C5F4',
        error: '#b71c1c',
        info: '#4F5760',
        warning: '#FFC107'
      },
      dark: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
}

Vue.use(Vuetify)

export default new Vuetify(opts)




// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetify.js